import { graphql } from "relay-runtime"

export const chForceDeleteProgressNoteMutation = graphql`
  mutation chForceDeleteProgressNoteMutation($input: Ch_forceDeleteProgressNoteInput!, $connections: [ID!]!) {
    forceDeleteProgressNote: ch_forceDeleteProgressNote(input: $input) {
      errors {
        ... on Error {
          message
        }
      }
      progressNote: ch_ProgressNote {
        id @deleteEdge(connections: $connections)
      }
    }
  }
`
